module.exports = __webpack_public_path__ + "svg/javascript.db38b4.svg";